<template>
    <div class="header-v3-box">
        <img v-if="styleTheam === 'index'" src="@/assets/img/index-v3-bg.png" alt="" class="bg-image"/>
        <img v-if="styleTheam === 'index'" src="@/assets/img/index-v3-bg1.png" alt="" class="bg1-image"/>
        <div :class="`theam-${styleTheam}`">
            <div class="header-title-box">
                <div class="logo" @click='$router.push("/")'>
                    <img src="@/assets/img/logo-v3.png">
                    <span class="logo-text">新语境教育</span>
                </div>
                <div class="header-link-box">
                    <div class="search-box-sm" :class="{'search-focus': isFocus}" v-if="styleTheam === 'normal'">
                        <input
                            ref="searchInputSm"
                            type="text"
                            v-if="isFocus"
                            v-model="searchValue"
                            placeholder="请输入您搜索的内容"
                            class="input-text-sm"
                            @click.stop="searchFocus"
                        />
                        <div class="btn-box" @click="searchClick">
                            <i class="search-icon-sm"></i>
                            <span class="search-btn-sm">搜索</span>
                        </div>
                    </div>
                    <p class="login-text" @click='$router.push("/login")'  v-if="!isLogin">
                        <span>注册/登录</span>
                    </p>   
                    <div class="user-header" v-else>
                        <el-avatar size="medium" :src="$store.state.baseUrl+userInfo.userImg" style="margin-right: 4px;"></el-avatar>
                        <div class="">{{'个人中心'}}</div>
                        <!-- <div class="">{{userInfo.name}}</div> -->
                        <div class="drop-menu-container">
                            <div class="drop-menu">
                                <div class="user-info">
                                    <el-avatar size="small" :src="$store.state.baseUrl+userInfo.userImg"></el-avatar>
                                    <div class="user-info-detail">
                                        <div class="user-info-phone">{{userInfo.phone}}</div>
                                        <div class="user-info-id">ID: {{userInfo.id}}</div>
                                    </div>
                                </div>
                                <div class="my-page" @click="$router.push('/personal')">我的个人主页</div>
                                <div class="logout-btn" @click="logout">退出登录</div>
                            </div>
                        </div>
                    </div>
                    <p @click='$router.push("/login2")'>远程教育平台</p>
                    <p>家庭教育平台 </p>
                    <p>终生教育平台</p>  
                </div>
            </div>
        </div>
        <div class="search-box" v-if="styleTheam === 'index'">
            <div class="search-input-box">
                <img src="@/assets/img/search-icon.png" class="search-icon">
                <input type="text" v-model="searchValue" placeholder="请输入您搜索的内容" class="input-text"/>
                <img src="@/assets/img/yuyin-icon.png" class="yuyin-icon">
            </div>
            <span class="search-btn" @click="$router.push({path: '/serch', query: {searchValue}})">
                搜索
            </span>
        </div>
        <div :class="`tab-box tab-theam-${styleTheam}`">
            <img v-if="styleTheam === 'index'" src="@/assets/img/index-v3-tab.png" class="tab-bg-img">
            <div class="tab-item-box">
                <div
                    class="tab-item"
                    :class="{'active': ['/', 'index'].indexOf(cur) !== -1}"
                    @click="$router.push('/')"
                    v-if="styleTheam === 'normal'"
                >
                    <span>首页</span>
                    <div class="line"></div>
                </div>
                <div
                    class="tab-item"
                    :class="{'active': cur == item.path}"
                    v-for="(item, index) in tabList"
                    :key="index"
                    @click="$router.push(item.path)"
                >
                    <span>{{ item.name }}</span>
                    <div class="line"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isFocus: false,
            searchValue: '', // 当前的搜索内容
            tabList: [
                {
                    name: '要闻动态',
                    path: '/news'
                },
                {
                    name: '走进新语境',
                    path: '/kmledu'
                },
                {
                    name: '团体标准',
                    path: '/standards'
                },
                {
                    name: '示范展示',
                    path: '/example'
                },
                {
                    name: '合作中心',
                    path: '/cooperation'
                },
                {
                    name: '服务中心',
                    path: '/service'
                }
            ]
        }
    },
    mounted() {
        window.addEventListener('click', this.searchBlur)
    },
    destroyed() {
        window.removeEventListener("click", this.searchBlur);
    },
    computed: {
        styleTheam() {
            let theam = 'index'
            const pathArray = ['/' , '/index', '/index/']
            let path = this.$route.path
            if (pathArray.indexOf(path) < 0) {
                theam = 'normal'
            }
            return theam;
        },
        cur() {
            
            let path = this.$route.path
            let rootPath = `/${path.split('/')[1]}`
            return rootPath
        },
        isLogin() {
            return this.$store.state.isLogin
        },
        userInfo() {
            return this.$store.state.userInfo
        },
    },
    methods: {
        logout() {
            this.$message.success('退出登录')
            window.localStorage.removeItem('token', null)
            window.localStorage.removeItem('userInfo', null)
            window.localStorage.setItem('isLogin', false)
            this.$store.commit("changeLogin", false);
            this.$store.commit("changeUser", null);
            this.$router.push('/login')
        },
        searchClick(e) {
            e.stopPropagation()
            let _this = this
            if (this.isFocus) {
                this.$router.push({
                    path: '/serch', 
                    query: {
                        searchValue: this.searchValue
                    }
                })
                this.searchBlur()
            } else {
                // 显示搜索框
                this.isFocus = true
                this.$nextTick(() => {
                    _this.$refs.searchInputSm.focus()
                })
            }
            
        },
        searchBlur(e) {
            this.isFocus = false
            this.searchValue = ''
        },
        searchFocus(e) {
            // 占位，阻止冒泡事件，防止在点击搜索框时window注册的点击事件方法将搜索框隐藏掉
        }
    }
}
</script>
<style lang="less" scoped>
.header-v3-box{
    // width: 1920px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .bg-image{
        width: 100%;
        height: 734px;
        object-fit: cover;
    }
    .bg1-image{
        width: 595.77px;
        height: 284.73px;
        position: absolute;
        top: 165px;
        object-fit: cover;
    }
    .theam-index{
        width: 100%;
        position: absolute;
        top: 0;
        padding: 36px 51px;
        color: #231F1E;
        .logo-text{
            color: #231F1E;
        }
        .login-text{
            color: #EA0603;
            span{
                padding-bottom: 6px;
                border-bottom: 1px solid #EA0603;
            }
        }
        .header-link-box{
            p {
                border-left: 1px solid #C1C1C1;
                &:first-of-type{
                    border-left: none;
                }
                &:hover{
                    color: #EA0603;
                }
            }
        }
    }
    .theam-normal{
        width: 100%; 
        padding: 10px 51px;
        background: #BD1A2D;
        color: #FFFFFF;
        border-bottom: 1px solid #C83737;
        .logo-text{
            color: #FFFFFF;
        }
        .login-text{
            color: #FFFFFF;
            span{
                padding-bottom: 6px;
                border-bottom: 1px solid #FFFFFF;
            }
        }
        .header-link-box{
            p { 
                border-left: 1px solid #FFFFFF;
                &:first-of-type{
                    border-left: none;
                }
                &:hover{
                    color: #FFFFFF;
                }
            }
        }
    }
    .header-title-box{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .logo{
        display: flex;
        align-items: center;
        cursor: pointer;
        img{
            width: 101px;
            height: 61px;
            margin-right: 20px;
        }
        .logo-text{
            font-size: 35px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            line-height: 51px;
        }
    }
    .header-link-box{
        font-size: 16px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        line-height: 21px;
        display: flex;
        align-items: center;
        p {
            // display: inline-block;
            padding: 0 39px; 
            cursor: pointer;
            &:last-of-type{
                border-right: none;
            }
        }
    }
    .search-box{
        position: absolute;
        bottom: 170px;
        width: 869px;
        height: 80px;
        display: flex;
        .search-input-box{
            flex: 1;
            display: flex;
            align-items: center;
            background: #FFFFFF;
            border-radius: 10px 0 0 10px;
            opacity: 1;
            border: 1px solid #DEDEDE;
            padding: 25px;
            .search-icon{
                width: 25px;
                height: 25px;
                margin-right: 20px;
            }
            .yuyin-icon{
                width: 21px;
            }
            .input-text{
                outline:none;
                flex: 1;
                font-size: 18px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #666666;
                line-height: 24px;
            }
        }
        .search-btn{
            width: 107px;
            height: 80px;
            background: #EA0603;
            border-radius: 0px 10px 10px 0px;
            border: 1px solid #EA0603;
            font-size: 18px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 80px;
            text-align: center;
            cursor: pointer;
            &:hover{
                background-color: rgba(234, 6, 3, 0.8);
            }
            &:active{
                background: #EA0603;
            }
        }
    }
    .search-focus{
        background: #FFFFFF;
        border-radius: 4px;
        padding: 0 11px;
        display: flex;
        align-items: center;
        width: 368px;
        height: 37px;
        .search-btn-sm{
            color: #BD1A2D!important;
        }
        .search-icon-sm{
            background: url('../assets/img/search-icon.png')!important;
            background-size: cover!important;
        }
    }
    .search-box-sm{
        margin: 0 39px 0 0;
        .input-text-sm{
            flex: 1;
            outline:none;
        }
        .btn-box{
            display: flex;
            align-items: center;
            cursor: pointer;
        }
        .search-icon-sm{
            width: 17.32px;
            height: 17.32px;
            margin-right: 4px;
            background: url('../assets/img/search-icon2.png');
            background-size: cover;
        }
        .search-btn-sm{
            font-size: 16px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 20px;
        }
    }
    .tab-box{
        .tab-bg-img{
            width: 1187px;
        }
        .tab-item-box{
            display: flex;
            align-items: center;
            .tab-item{
                font-weight: bold;
                color: #FFBBBB;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                &:hover{
                    color: #FFFFFF;
                    .line{
                        opacity: 1;
                    }
                }
            }
            .line{
                height: 3px;
                // border: 3px solid #FFFFFF;
                background: #FFFFFF;
                border-radius: 4px;
                opacity: 0;
            }
            .active{
                color: #FFFFFF;
                .line{
                    opacity: 1;
                }
            }
        }
    }
    .tab-theam-index{
        position: absolute;
        bottom: 0;
        width: 100%;
        .tab-item-box{
            position: absolute;
            bottom: 0;
            padding: 0 0 0 181.5px;
            .tab-item{
                padding: 30px 33.5px 35px;
                font-size: 18px;
                font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                line-height: 24px;
            }
            .line{
                width: 38px;
                margin-top: 10px;
            }
            .active{
                color: #FFFFFF;
                .line{
                    opacity: 1;
                }
            }
        }
    }
    .tab-theam-normal{
        width: 100%;
        background: #BD1A2D;
        .tab-item-box{
            width: 1200px;
            margin: 0 auto;
            .tab-item{
                padding: 38px 50.5px 18px;
                font-size: 18px;
                font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                line-height: 29px;
                &:first-of-type{
                    padding-left: 0;
                }
                &:last-of-type{
                    padding-right: 0;
                }
            }
            .line{
                width: 70px;
                margin-top: 18px;
            }
            .active{
                color: #FFFFFF;
                .line{
                    opacity: 1;
                }
            }
        }
    }
    .user-header{
        display: flex;
        align-items: center;
        cursor: pointer;
        position: relative;
        // border: 1px solid red;
        // padding-bottom: 10px;
        padding: 0 39px; 
        .header-icon{
            height: 36px;
            width: 36px;
            background: #0093DD;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 8px;
            color: #FFF;
        }
        &:hover .drop-menu-container{
            display: block;
        }
        .drop-menu-container{
            display: none;
            position: absolute;
            bottom: -170px;
            z-index: 10;
            // border: 1px solid red;
            transform: translateX(-25%);
            padding-top: 10px;
        }
        .drop-menu{
            width: 210px;
            height: 160px;
            box-shadow: 0  2px 5px rgba(0, 0, 0, 0.4);

            border-radius: 8px;
            background-color: #FFF;
            box-sizing: border-box;
            padding: 11px 23px;
            .user-info{
                display: flex;
                align-items: center;
            }
            .user-info-detail{
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #666666;
                margin-left: 14px;
                .user-info-id{
                    margin-top: 5px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                }
            }
            .my-page{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                margin-top: 22px;
                border-bottom: 1px solid #eee;
                padding-bottom: 18px;
                cursor: pointer;
            }
            .logout-btn{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                margin-top: 9px;
                cursor: pointer;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/header-v3.vue